import { CeVoucherBatchDetailsStatus, HubFeature } from '@ats/api/cm';
import { LocDef, LocDefs, MapLocKeys } from '../../models';
import { LocDisplayType } from '../../models/display-type';
import { SYSTEM_ENUM_ROOT, SYSTEM_ENUM_TYPE } from '../shared-data';

const dpRoot = `${SYSTEM_ENUM_ROOT}|CE Voucher Batch Detail Status|`;

const sharedLocData: Pick<LocDef, 'displayType' | 'htmlAllowed' | 'shared' | 'feature' | 'portal'> =
	{
		displayType: `${SYSTEM_ENUM_TYPE}` as LocDisplayType,
		htmlAllowed: false,
		shared: true,
		feature: HubFeature.Credential,
		portal: 'SP',
	};

export type SPCeVoucherBatchDetailStatusLocs =
	| `SPCEVoucherBatchDetailStatusExpired`
	| `SPCEVoucherBatchDetailStatusRedeemed`
	| `SPCEVoucherBatchDetailStatusRevoked`
	| `SPCEVoucherBatchDetailStatusValid`;

export const spCEVoucherBatchDetailStatusEnumLocs: LocDefs<SPCeVoucherBatchDetailStatusLocs> = {
	SPCEVoucherBatchDetailStatusExpired: {
		defaultValue: 'Expired',
		displayPath: `${dpRoot}${CeVoucherBatchDetailsStatus.Expired}`,
		description: `System value for '${CeVoucherBatchDetailsStatus.Expired}' CE Voucher Batch Detail Status`,
		...sharedLocData,
	},
	SPCEVoucherBatchDetailStatusRedeemed: {
		defaultValue: 'Redeemed',
		displayPath: `${dpRoot}${CeVoucherBatchDetailsStatus.Redeemed}`,
		description: `System value for '${CeVoucherBatchDetailsStatus.Redeemed}' CE Voucher Batch Detail Status`,
		...sharedLocData,
	},
	SPCEVoucherBatchDetailStatusRevoked: {
		defaultValue: 'Revoked',
		displayPath: `${dpRoot}${CeVoucherBatchDetailsStatus.Revoked}`,
		description: `System value for '${CeVoucherBatchDetailsStatus.Revoked}' CE Voucher Batch Detail Status`,
		...sharedLocData,
	},
	SPCEVoucherBatchDetailStatusValid: {
		defaultValue: 'Valid',
		displayPath: `${dpRoot}${CeVoucherBatchDetailsStatus.Valid}`,
		description: `System value for '${CeVoucherBatchDetailsStatus.Valid}' CE Voucher Batch Detail Status`,
		...sharedLocData,
	},
};

export const sPCeVoucherBatchDetailStatusKeys = MapLocKeys<SPCeVoucherBatchDetailStatusLocs>(
	spCEVoucherBatchDetailStatusEnumLocs
);
export type SPCeVoucherBatchDetailStatusKeys = typeof sPCeVoucherBatchDetailStatusKeys;

export const spCEVoucherBatchDetailStatusKeys: {
	[key in CeVoucherBatchDetailsStatus]: keyof SPCeVoucherBatchDetailStatusKeys;
} = {
	[CeVoucherBatchDetailsStatus.Expired]:
		sPCeVoucherBatchDetailStatusKeys.SPCEVoucherBatchDetailStatusExpired,
	[CeVoucherBatchDetailsStatus.Redeemed]:
		sPCeVoucherBatchDetailStatusKeys.SPCEVoucherBatchDetailStatusRedeemed,
	[CeVoucherBatchDetailsStatus.Revoked]:
		sPCeVoucherBatchDetailStatusKeys.SPCEVoucherBatchDetailStatusRevoked,
	[CeVoucherBatchDetailsStatus.Valid]:
		sPCeVoucherBatchDetailStatusKeys.SPCEVoucherBatchDetailStatusValid,
};
